
              const Handlebars = require('handlebars');
              const templateFunction = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div class=\"row\">\n	<div class=\"directory-details-top\">\n		<a class=\"backToServiceTypesListLink\" href=\"#services/servicetypes\" title=\"Back to service types list\"><span class=\"fa fa-arrow-left\"></span>Back to service types list</a>\n	</div>\n</div>\n";
  },"useData":true});
              Handlebars.templates['src/hbs/partials/entity_list_controls.hbs'] = templateFunction;
              export default templateFunction;
              